<div class="relative w-full">
    @if (data.length > maxBars && showViewAllButton) {
        <div class="flex justify-end mb-2">
            <button 
                (click)="onViewAll()"
                class="px-3 py-1.5 text-[11px] font-bold text-purple-600 dark:text-purple-400 
                       bg-purple-50/50 dark:bg-purple-900/20 
                       border border-purple-100 dark:border-purple-800/50 
                       rounded-lg hover:bg-purple-100/50 dark:hover:bg-white/10 
                       transition-all active:scale-95 cursor-pointer">
                View All
            </button>
        </div>
    }
    <div #chartContainer class="w-full"></div>
</div>
